import React from 'react';
import Color from './color';

class ChosenColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      className: 'animation--in'
    };
  }

  handleClick() {
    if (this.state.className === 'animation--in') {
      this.setState({
        className: 'animation--out'
      });
    }
  }

  handleAnimationEnd() {
    if (this.state.className === 'animation--out') {
      this.props.onClick();
    }
  }

  render() {
    return (
      <Color
        color={this.props.color}
        className={this.state.className}
        onClick={() => this.handleClick()}
        onAnimationEnd={() => this.handleAnimationEnd()}
      />
    );
  }
}

export default ChosenColor;



// WEBPACK FOOTER //
// ./src/components/chosenColor.js